import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import Page from '../../components/Page';
// import { useNavigate } from 'react-router-dom';
//Material
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
// import PersonOffOutlinedIcon from '@mui/icons-material/PersonOffOutlined';
import { Avatar, Box, Grid, Stack, Typography } from '@mui/material';
import { ToTopBtnFree } from '../../components/Buttons';
import ApiService from '../../helpers/apiHelper';
import '../MainPage/index.css';

import InfiniteScroll from 'react-infinite-scroll-component';
import { Element } from 'react-scroll';
import DefaultAvatar from '../../assets/defaultPostImg.jpg';
import { Spinner } from '../../components/Spinner';
import { StyledTitle } from '../../components/StyledComponents';
import { renderBanner } from '../../components/Banners/Banners';
import PostCard from '../../components/PostCard';
import ServiceCardRibbonInt from '../../components/ServiceCardRibbonInt';
import BigSwitcher from '../../components/BigSwitcher';
import { Add } from '@mui/icons-material';
import { base } from '../../redux/thunk';

// import { Spinner } from '../../components/Spinner';

function RibbonPage({ userData, subscriptions, getUserSubscriptionsThunk }) {
  // eslint-disable-next-line
  const [containerHeight, setContainerHeight] = useState(0);
  const [page, setPage] = useState(0);
  const [pageScroll, setPageScroll] = useState(0);
  const [loadMore, setLoadMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [contentMaxCount, setContentMaxCount] = useState(0);
  const [contentSwitched, setContentSwitched] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingUsers, setIsLoadingUsers] = useState(false);
  const [isLoadingServices, setIsLoadingServices] = useState(false);
  const [content, setContent] = useState([]);
  const [users, setUsers] = useState([]);
  const [services, setServices] = useState([]);
  const [randomDesc, setRandomDesc] = useState(0);
  const [bools, setBools] = useState([true, false]);
  const descriptions = [
    'На даний момент у вас немає новин. Як тільки щось попадеться під руку - одразу покажем.',
    'Зараз новин немає, але цей момент не за горами. Перевірте цю сторінку пізніше.',
    'Зараз тут і кіт не валявся. Але скоро будуть новини. Подивіться поки вкладку “Цікавеньке”'
  ];
  const apiSubscribe = new ApiService('auth/subscribe');

  // const apiInterestingUsers = new ApiService('/get-interested-user');
  // const apiInterestingServices = new ApiService('ribbon/get-interested-services');
  // const apiInteresting = new ApiService('/ribbon/get-all-interested');
  // const apiSubscribers = new ApiService('/ribbon/get-all-my-subscribers');

  const apiInterestingUsers = new ApiService('auth/get-interested-user');
  const apiInterestingServices = new ApiService('posts/ribbon/get-interested-services');
  const apiInteresting = new ApiService('posts/ribbon/get-all-interested');
  const apiSubscribers = new ApiService('posts/ribbon/get-all-my-subscribers');

  // const isOpenServiceModal = useSelector((state) => state.global.isOpenServiceModal);

  // const [params] = useSearchParams();
  // const navigate = useNavigate();
  // console.log(contentSwitched);
  // const testUsers = ['1', '2', '3'];
  // function getFileFromBase64(string64, fileName) {
  //   const trimmedString = string64.replace('dataimage/jpegbase64', '');
  //   const imageContent = atob(trimmedString);
  //   const buffer = new ArrayBuffer(imageContent.length);
  //   const view = new Uint8Array(buffer);

  //   for (let n = 0; n < imageContent.length; n++) {
  //     view[n] = imageContent.charCodeAt(n);
  //   }
  //   const type = 'image/jpeg';
  //   const blob = new Blob([buffer], { type });
  //   return new File([blob], fileName, { lastModified: new Date().getTime(), type });
  // }

  const handleChange = (isOne, isTwo) => {
    if (isOne) {
      setContentSwitched(false);
      setBools([true, false]);
    } else {
      setContentSwitched(true);
      setBools([false, true]);
    }

    setPage(0);
    setHasMore(true);
  };

  const interestedContentSetter = () => {
    setUsers([]);
    setServices([]);
    setIsLoadingUsers(true);
    setIsLoadingServices(true);
    // apiInterestingUsers.getAll({ userId: userData.id }).then((res) => {
    apiInterestingUsers
      .getAll({ maxAmountUsers: 7 })
      .then((res) => {
        setUsers(res.result);
        setIsLoadingUsers(false);
      })
      .catch((error) => setIsLoadingUsers(false));
    apiInterestingServices
      .getAll({ userId: userData?.id })
      .then((res) => {
        setServices(res.result);
        setIsLoadingServices(false);
      })
      .catch((error) => setIsLoadingServices(false));
  };
  const dataSetter = () => {
    setIsLoading(true);
    setContent([]);
    if (!contentSwitched) {
      apiInteresting
        .getAll({ userId: userData.id, from: 0, size: 5 })
        .then((res) => {
          setContent(res.result);
          setContentMaxCount(res.totalElements);
          // setContentSwitched(false);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error(error);
          setIsLoading(false);
        });
    } else {
      apiSubscribers
        .getAll({ userId: userData.id, from: 0, size: 5 })
        .then((res) => {
          setContent(res.result);
          // setContent([]);
          setContentMaxCount(res.totalElements);
          // setContentSwitched(true);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error(error);
          setIsLoading(false);
        });
    }
  };
  const handleLoadMore = () => {
    setLoadMore(true);

    if (!contentSwitched) {
      apiInteresting
        .getAll({ userId: userData.id, from: page + 5, size: 5 })
        .then((res) => {
          setContent([...content, ...res.result]);
          setContentMaxCount(res.totalElements);
          setPage(page + 5);
          setLoadMore(false);
        })
        .catch((error) => {
          console.error(error);
          setLoadMore(false);
        });
    } else {
      apiSubscribers
        .getAll({ userId: userData.id, from: page + 5, size: 5 })
        .then((res) => {
          setContent([...content, ...res.result]);
          setPage(page + 5);
          setContentMaxCount(res.totalElements);
          setLoadMore(false);
        })
        .catch((error) => {
          console.error(error);
          setLoadMore(false);
        });
    }
  };

  // eslint-disable-next-line

  // const [anchorEl, setAnchorEl] = useState(null);
  // const open = Boolean(anchorEl);
  useEffect(() => {
    if (userData?.id) {
      if (!contentSwitched) {
        // setContentSwitched(false);
        dataSetter(false);
      } else {
        // setContentSwitched(true);
        dataSetter(true);
      }
    }
    // eslint-disable-next-line
  }, [contentSwitched]);

  const intervalRef = useRef(null);
  useEffect(() => {
    if (userData?.id) {
      if (!intervalRef.current) {
        interestedContentSetter();
        intervalRef.current = setInterval(() => interestedContentSetter(), 600000);
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
    // eslint-disable-next-line
  }, [userData]);

  useEffect(() => {
    setRandomDesc(Math.floor(Math.random() * descriptions.length));
    // eslint-disable-next-line
  }, []);
  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };
  useEffect(() => {
    const container = document.getElementById('scrollableDiv');
    if (container) {
      container.addEventListener('scroll', () => setPageScroll(container.scrollTop));
    }
    return () => {
      if (container) {
        container.removeEventListener('scroll', () => setPageScroll(container.scrollTop));
      }
    };
  });
  useEffect(() => {
    if (content.length !== 0 && content.length >= contentMaxCount) {
      setHasMore(false);
    } else {
      setHasMore(true);
    }
    // eslint-disable-next-line
  }, [content]);
  useEffect(() => {
    const height = document.getElementById('leftContainer');
    if (height && height?.clientHeight) {
      setContainerHeight(height.clientHeight);
    }
  }, [users, services]);
  return (
    <Page
      title="Стрічка"
      sx={{
        display: 'flex',
        marginTop: '100px',
        alignItems: 'center',
        flexDirection: 'column',
        height: 'max-content',
        padding: { xs: '0px 20px', sm: '0px 20px', md: '0px 50px', lg: '60px 100px' }
      }}
    >
      <Element name="topRibbonPage" />
      {/*<Stack*/}
      {/*  spacing={1}*/}
      {/*  justifyContent="center"*/}
      {/*  alignItems="center"*/}
      {/*  style={{ marginBottom: '100px' }}*/}
      {/*>*/}
      <Grid
        container
        sx={{
          width: '100%'
          // minWidth: '1240px'
        }}
        spacing={{ xs: 0, sm: 2 }}
      >
        {/* <Grid item xs={4} /> */}
        <Grid
          id="leftContainer"
          item
          xs={3}
          sm={5}
          lg={3}
          sx={
            {
              // position: 'fixed',
              // maxWidth: '421.66px',
              display: { xs: 'none', sm: 'block' },
              height: 'fit-content',
              minHeight: '500px',
              top: '193px',
              overflowX: 'hidden'
            }
            // { position: 'unset', maxWidth: '421.66px' }
          }
        >
          {isLoadingUsers ? (
            <div
              style={{
                // height: '240px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                marginBottom: '100px'
              }}
            >
              <Typography
                variant="subtitle"
                component={'p'}
                sx={{
                  fontSize: { xs: '12px', sm: '16px' },
                  fontFamily: 'FixelText-Medium',
                  fontWeight: '500',
                  mb: { xs: '0px', sm: '8px' }
                }}
              >
                Цікаві користувачі:
              </Typography>
              <Spinner />
            </div>
          ) : null}

          {users.length !== 0 ? (
            <>
              <Typography
                variant="subtitle"
                component={'p'}
                sx={{
                  fontSize: { xs: '12px', sm: '16px' },
                  fontFamily: 'FixelText-Medium',
                  fontWeight: '500',
                  mb: { xs: '0px', sm: '8px' }
                }}
              >
                Цікаві користувачі:
              </Typography>

              {users.map((user, index) => (
                <Box
                  sx={{
                    display: 'flex',
                    p: '8px',
                    gap: '8px',
                    alignItems: 'space-between',
                    justifyContent: 'center',
                    boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                    borderRadius: '8px',
                    mr: '6px'
                  }}
                >
                  <Avatar
                    src={user?.photoUrl ? user?.photoUrl : DefaultAvatar}
                    onClick={() => window.open(`${window.location.origin}/ua/user-page/${user.id}`)}
                    sx={{
                      width: '40px',
                      height: '40px',
                      border: '1px solid  #E2F2FF',
                      boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                      cursor: 'pointer',
                      mt: 'auto',
                      mb: 'auto'
                    }}
                  />
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'flex-start',
                      alignItems: 'flex-start',
                      width: '100%'
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { xs: '12px' },
                        margin: '0px 0px 0px',
                        fontFamily: 'FixelText-Medium',
                        textAlign: 'left',
                        fontWeight: '500',
                        color: '#7C7C7C'
                      }}
                    >
                      {`@${user?.nickname}`}
                    </Typography>
                    <Stack
                      sx={{
                        width: '100%',
                        overflow: 'hidden',
                        gap: { xs: '5px', sm: '8px' },
                        flexWrap: 'wrap',
                        alignItems: { xs: 'start', sm: 'center' },
                        justifyContent: { xs: 'start', sm: 'center' },
                        mt: '0px !important',
                        maxWidth: { xs: '231px', sm: 'unset' }
                      }}
                      direction="row"
                    >
                      {user?.surname && (
                        <Typography
                          sx={{
                            fontSize: { xs: '14px' },
                            lineHeight: { xs: '14px' },
                            textAlign: { xs: 'left' },
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            fontFamily: 'FixelText-Medium',
                            fontWeight: '500',
                            width: '100%'
                          }}
                        >
                          {user.surname}
                        </Typography>
                      )}
                      {user?.name && (
                        <Typography
                          sx={{
                            fontSize: { xs: '14px' },
                            lineHeight: { xs: '14px' },
                            textAlign: { xs: 'left' },
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            fontFamily: 'FixelText-Medium',
                            fontWeight: '500',
                            width: '100%'
                          }}
                        >
                          {user.name}
                        </Typography>
                      )}
                    </Stack>
                  </Box>
                  {!subscriptions.find((subscription) => subscription.id === user.id) && (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Add
                        sx={{ color: '#60A5DF', cursor: 'pointer' }}
                        onClick={(event) => {
                          event.stopPropagation();
                          event.preventDefault();

                          if (!subscriptions.find((subscription) => subscription.id === user.id)) {
                            apiSubscribe
                              .updateDataQuery({ subscriptionId: user.id })
                              .then((res) => {
                                getUserSubscriptionsThunk(userData.id);
                              });
                          }
                        }}
                      />
                    </Box>
                  )}
                </Box>
              ))}
            </>
          ) : null}
          {isLoadingServices ? (
            <div
              style={{
                // height: '240px',

                display: { xs: 'flex', md: 'none' },
                flexDirection: 'column',
                justifyContent: 'center'
              }}
            >
              <Typography
                variant="subtitle"
                component={'p'}
                sx={{
                  display: { xs: 'inline-block', md: 'none' },
                  fontSize: { xs: '12px', sm: '16px' },
                  fontFamily: 'FixelText-Medium',
                  fontWeight: '500',
                  mb: { xs: '0px', sm: '8px' }
                }}
              >
                Можуть вам сподобатися:
              </Typography>
              <Spinner />
            </div>
          ) : null}

          {services.length !== 0 ? (
            <Box sx={{ display: { xs: 'block', md: 'none' } }}>
              {' '}
              <Typography
                variant="subtitle"
                component={'p'}
                sx={{
                  display: { xs: 'inline-block', md: 'none' },
                  fontSize: { xs: '12px', sm: '16px' },
                  fontFamily: 'FixelText-Medium',
                  fontWeight: '500',
                  mb: { xs: '0px', sm: '8px', md: '24px' }
                }}
              >
                Можуть вам сподобатися:
              </Typography>
              {services.map((service, index) => (
                <ServiceCardRibbonInt
                  noWidth
                  maxHeight="327px"
                  key={index}
                  index={index}
                  el={service}
                />
              ))}
            </Box>
          ) : null}
        </Grid>
        <Grid
          item
          xs={12}
          sm={7}
          lg={6}
          sx={{
            paddingBottom: '0px',
            position: 'relative',
            minHeight: '83vh'
          }}
          id="scrollParrent"
        >
          <Box sx={{ display: pageScroll > 0 ? 'none' : 'block' }}>
            <BigSwitcher
              bools={bools}
              textOne="Цікавеньке"
              textTwo="Мої підписки"
              handleToggle={handleChange}
            />
          </Box>
          {users.length !== 0 && (
            <Box
              sx={{
                display: { xs: 'flex', sm: 'none' },
                flexDirection: 'column',
                p: '4px',
                boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                borderRadius: '8px',
                justifyContent: 'center',
                alignItems: 'flex-start',
                bgcolor: 'background.paper',
                mb: '18px',
                position: 'sticky',
                top: '85px',
                zIndex: 999,
                border: '1px solid  #E2F2FF',
                ml: 'auto',
                mr: 'auto'
              }}
            >
              {isLoadingUsers ? (
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    marginBottom: '40px'
                  }}
                >
                  <Typography
                    variant="subtitle"
                    component={'p'}
                    sx={{
                      fontSize: { xs: '12px', sm: '16px' },
                      fontFamily: 'FixelText-Medium',
                      fontWeight: '500',
                      mb: { xs: '0px', sm: '8px' }
                    }}
                  >
                    Цікаві користувачі:
                  </Typography>
                  <Spinner type="small" />
                </div>
              ) : null}
              {users.length !== 0 ? (
                <>
                  {' '}
                  <Typography
                    variant="subtitle"
                    component={'p'}
                    sx={{
                      fontSize: { xs: '12px', sm: '16px' },
                      fontFamily: 'FixelText-Medium',
                      fontWeight: '500',
                      mb: { xs: '0px', sm: '8px' }
                    }}
                  >
                    Цікаві користувачі:
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'start',
                      alignItems: 'center',
                      overflowX: 'scroll',
                      maxWidth: '100%',
                      scrollbarWidth: 'none',
                      gap: '4px',
                      '&::-webkit-scrollbar': {
                        display: 'none'
                      }
                    }}
                  >
                    {users.map((user, index) => (
                      <Avatar
                        onClick={() =>
                          window.open(`${window.location.origin}/ua/user-page/${user.id}`)
                        }
                        sx={{
                          width: '43.8px',
                          height: '43.8px',
                          border: '1px solid  #E2F2FF',
                          boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)'
                        }}
                        src={user?.photoUrl ? user?.photoUrl : DefaultAvatar}
                        index={index}
                        key={`user-ribbon-${index}`}
                      />
                    ))}
                  </Box>
                </>
              ) : null}
            </Box>
          )}

          <ToTopBtnFree
            top="75%"
            onClick={() => {
              const container = document.getElementById('scrollableDiv');
              container.childNodes[0].scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'start'
              });
            }}
            visible={pageScroll > 700}
            // sx={{ position: 'absolute', right: '8px !important', bottom: '0' }}
            icon={<ArrowUpwardIcon sx={{ fontSize: '22px' }} />}
          />
          {content.length === 0 ? (
            <>
              {isLoading ? (
                <div style={{ marginTop: '40%', marginBottom: '180px' }}>
                  <Spinner />
                </div>
              ) : (
                <Stack spacing={5} alignItems="center">
                  {!contentSwitched ? (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <StyledTitle
                        maxWidth={800}
                        sx={{
                          lineHeight: '38px !important',
                          fontSize: '32px !important',
                          textTransform: 'initial !important',
                          margin: '80px auto 0px !important'
                        }}
                        className="bottomBlock-title"
                      >
                        Упс, тут пусто
                      </StyledTitle>
                      <Typography
                        style={{
                          fontStyle: 'normal',
                          fontWeight: '400',
                          fontSize: '16px',
                          lineHeight: '29px',
                          textAlign: 'center',
                          margin: '30px 0px 40px 0px',
                          maxWidth: '500px'
                        }}
                      >
                        {descriptions[randomDesc]}
                      </Typography>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <StyledTitle
                        maxWidth={800}
                        sx={{
                          lineHeight: '38px !important',
                          fontSize: '32px !important',
                          textTransform: 'initial !important',
                          margin: '80px auto 0px !important'
                        }}
                        className="bottomBlock-title"
                      >
                        Упс, тут пусто
                      </StyledTitle>
                      <Typography
                        style={{
                          fontStyle: 'normal',
                          fontWeight: '400',
                          fontSize: '16px',
                          lineHeight: '29px',
                          textAlign: 'center',
                          margin: '30px 0px 40px 0px',
                          maxWidth: '500px'
                        }}
                      >
                        {descriptions[randomDesc]}
                      </Typography>
                    </div>
                  )}
                </Stack>
              )}
            </>
          ) : (
            <InfiniteScroll
              dataLength={content.length}
              next={handleLoadMore}
              hasMore={hasMore}
              scrollableTarget="scrollableDiv"
              scrollThreshold="1000px"
            >
              <>
                <Grid
                  id="scrollableDiv"
                  container
                  spacing={2}
                  sx={{
                    overflowY: 'scroll',
                    // maxHeight: containerHeight,
                    maxHeight: { xs: '660px', sm: '1360px' },
                    p: '4px',
                    justifyContent: 'center',
                    display: 'flex'
                  }}
                >
                  {content.map((el, index) => {
                    const getContent = () => {
                      if (el.contentType === 'SERVICE' || el.contentType === 'PROMOTED_SERVICE') {
                        return (
                          <Grid key={`service${index}`} item xs={12}>
                            <ServiceCardRibbonInt
                              isInRibbon={true}
                              noWidth
                              sx={{ marginBottom: '10px !important' }}
                              key={index}
                              index={index}
                              el={el}
                            />
                          </Grid>
                        );
                      }

                      if (el.contentType === 'POST') {
                        return (
                          <Grid key={`post${index}`} item xs={12}>
                            <PostCard
                              noWidth
                              sx={{ marginBottom: '10px !important' }}
                              key={index}
                              index={index}
                              el={el}
                              dataSetter={dataSetter}
                              isInRibbon={true}
                            />
                          </Grid>
                        );
                      }

                      if (el.contentType === 'ADVERTISING_BANNER') {
                        return (
                          <Grid key={`banner${index}`} item xs={12}>
                            {renderBanner(el?.numberOfAdvertisingBanner)}
                          </Grid>
                        );
                      }
                    };
                    return getContent();
                  })}
                  {loadMore ? (
                    <Grid key={`spinner`} item xs={12} sx={{ marginTop: '5%', marginBottom: '5%' }}>
                      <Spinner />
                    </Grid>
                  ) : null}
                </Grid>
                {services.length !== 0 && (
                  <Box
                    id="bottomInterested"
                    sx={{
                      display: { xs: 'flex', sm: 'none' },
                      flexDirection: 'column',
                      p: '4px',
                      boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                      borderRadius: '8px',
                      justifyContent: 'center',
                      alignItems: 'flex-start',
                      bgcolor: 'background.paper',
                      mt: '12px',
                      zIndex: 999,
                      border: '1px solid  #E2F2FF',
                      ml: 'auto',
                      mr: 'auto',
                      position: 'sticky',
                      left: '20px',
                      right: '20px',
                      transform: 'unset',
                      width: 'unset',
                      bottom: '8px'
                    }}
                  >
                    {isLoadingServices ? (
                      <div
                        style={{
                          width: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          marginBottom: '40px'
                        }}
                      >
                        <Typography
                          variant="subtitle"
                          component={'p'}
                          sx={{
                            fontSize: { xs: '12px', sm: '16px' },
                            fontFamily: 'FixelText-Medium',
                            fontWeight: '500',
                            mb: { xs: '0px', sm: '8px' }
                          }}
                        >
                          Можуть Вам сподобатись:
                        </Typography>
                        <Spinner type="small" />
                      </div>
                    ) : null}
                    {services.length !== 0 ? (
                      <>
                        {' '}
                        <Typography
                          variant="subtitle"
                          component={'p'}
                          sx={{
                            fontSize: { xs: '12px', sm: '16px' },
                            fontFamily: 'FixelText-Medium',
                            fontWeight: '500',
                            mb: { xs: '0px', sm: '8px' }
                          }}
                        >
                          Можуть Вам сподобатись:
                        </Typography>
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'start',
                            alignItems: 'center',
                            overflowX: 'scroll',
                            maxWidth: '100%',
                            scrollbarWidth: 'none',
                            gap: '4px',
                            p: '4px',
                            '&::-webkit-scrollbar': {
                              display: 'none'
                            }
                          }}
                        >
                          {services.map((service, index) => (
                            <ServiceCardRibbonInt el={service} />
                          ))}
                        </Box>
                      </>
                    ) : null}
                  </Box>
                )}
              </>
            </InfiniteScroll>
          )}
        </Grid>

        <Grid
          item
          xs={3}
          sx={{ display: { xs: 'none', md: 'flex', flexDirection: 'column', gap: '8px' } }}
        >
          {isLoadingServices ? (
            <div
              style={{
                // height: '240px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
              }}
            >
              <Typography
                variant="subtitle"
                component={'p'}
                sx={{
                  fontSize: { xs: '12px', sm: '16px' },
                  fontFamily: 'FixelText-Medium',
                  fontWeight: '500',
                  mb: { xs: '0px', sm: '8px' }
                }}
              >
                Можуть вам сподобатися:
              </Typography>
              <Spinner />
            </div>
          ) : null}

          {services.length !== 0 ? (
            <>
              {' '}
              <Typography
                variant="subtitle"
                component={'p'}
                sx={{
                  fontSize: { xs: '12px', sm: '16px' },
                  fontFamily: 'FixelText-Medium',
                  fontWeight: '500',
                  mb: { xs: '0px', sm: '8px', md: '24px' }
                }}
              >
                Можуть вам сподобатися:
              </Typography>
              {services.map((service, index) => (
                // <ServiceCard noWidth maxHeight="327px" key={index} index={index} el={service} />
                <ServiceCardRibbonInt
                  noWidth
                  maxHeight="327px"
                  key={index}
                  index={index}
                  el={service}
                />
              ))}
            </>
          ) : null}
        </Grid>
      </Grid>

      {/*</Stack>*/}
    </Page>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData,
    subscribers: state.global.userSubscribers,
    subscriptions: state.global.userSubscriptions
  };
};
export default connect(mapStateToProps, {
  getUserSubscribersThunk: base.getUserSubscribersThunk,
  getUserSubscriptionsThunk: base.getUserSubscriptionsThunk
})(RibbonPage);
